module.exports = __webpack_public_path__ + "static/381-53b109bc66d46c898dc50e7fd47ca4a4.jpg";